import Icon from "core/assets/icons";
import SelectImage from "./SelectImage";
import PostShared from "./PostShared";
import { useCreate } from './../../hooks'
import { getFieldInputProps } from "core/utils/form";
import { Button, CTextArea } from "core/components/form-controls";
import { _t } from "core/language";

const maxLength = 1500;

export default function CommunityForm() {

  const {
    formik,
    post,
    postType,
    onRemovePost,
    canSelectImage,
    toggleSelectImage,
    loading,
    error,
  } = useCreate();

  return (
    <form onSubmit={formik.onSubmit} className="mx-auto space-y-[30px] bg-white">
      <div className="space-y-[3px]">
        <div className="w-full max-w-md">
          <div className="border border-primary rounded-lg">
            <div className="p-3">
              <CTextArea
                className="w-full outline-none resize-none text-[#333333] text-[13px]"
                placeholder={_t("comunity.create.content_placeholder")}
                {...getFieldInputProps(formik, 'content')}
                maxLength={maxLength}
                rows={4}
              />
              {canSelectImage && <div className="flex justify-between items-center gap-3">
                <SelectImage />
              </div>}
            </div>
            <div className="flex justify-between items-center bg-[#F8F8F8] rounded-bl-lg rounded-br-lg px-[6px] py-[12.5px]">
              <div className={`flex space-x-2 text-[10px] ${!canSelectImage ? 'opacity-50' : ''}`} onClick={() => toggleSelectImage()}>
                <img src={Icon.ImagePlus} alt={'ImagePlus'} />
              </div>
              <span className="text-[#777777] text-[10px]">
                {formik.values?.content?.length}/{maxLength}
              </span>
            </div>
          </div>
          {error?.errors?.length && !formik.values?.content?.length && !formik.values?.images?.length ? (
            <p className="text-red-500 text-[12px] mt-1">
              {error?.errors?.[0].error}
            </p>
          ) : null}
        </div>

        {post && <PostShared postType={postType} post={post} onRemovePost={onRemovePost} />}
      </div>

      <Button
        size="lg"
        type="submit"
        primary
        label={_t("comunity.create.submit")}
        iconRight={!loading ? Icon.SharePostWhite : undefined}
        classBtn="w-full rounded-full text-[15px] font-medium tracking-tighter [&_.animate-spin]:border-white [&_.animate-spin]:border-t-transparent"
        loading={loading}
        disabled={
          !formik.values?.content?.length
          && !formik.values?.images?.length
          && !formik.values?.post_share
        }
      />
    </form>
  );
}
